import { type MantineColorsTuple } from '@mantine/core'

const shadeRed: MantineColorsTuple = [
  '#fef2f2',
  '#fee2e2',
  '#fecaca',
  '#fca5a5',
  '#f87171',
  '#ef4444',
  '#dc2626',
  '#b91c1c',
  '#991b1b',
  '#7f1d1d',
  '#450a0a',
]

const shadeOrange: MantineColorsTuple = [
  '#fff7ed',
  '#ffedd5',
  '#fed7aa',
  '#fdba74',
  '#fb923c',
  '#f97316',
  '#ea580c',
  '#c2410c',
  '#9a3412',
  '#7c2d12',
  '#431407',
]

const shadeAmber: MantineColorsTuple = [
  '#fffbeb',
  '#fef3c7',
  '#fde68a',
  '#fcd34d',
  '#fbbf24',
  '#f59e0b',
  '#d97706',
  '#b45309',
  '#92400e',
  '#78350f',
  '#451a03',
]

const shadeYellow: MantineColorsTuple = [
  '#fefce8',
  '#fef9c3',
  '#fef08a',
  '#fde047',
  '#facc15',
  '#eab308',
  '#ca8a04',
  '#a16207',
  '#854d0e',
  '#713f12',
  '#422006',
]

const shadeLime: MantineColorsTuple = [
  '#f7fee7',
  '#ecfccb',
  '#d9f99d',
  '#bef264',
  '#a3e635',
  '#84cc16',
  '#65a30d',
  '#4d7c0f',
  '#3f6212',
  '#365314',
  '#1a2e05',
]

const shadeGreen: MantineColorsTuple = [
  '#f0fdf4',
  '#dcfce7',
  '#bbf7d0',
  '#86efac',
  '#4ade80',
  '#22c55e',
  '#16a34a',
  '#15803d',
  '#166534',
  '#14532d',
  '#052e16',
]

const shadeEmerald: MantineColorsTuple = [
  '#ecfdf5',
  '#d1fae5',
  '#a7f3d0',
  '#6ee7b7',
  '#34d399',
  '#10b981',
  '#059669',
  '#047857',
  '#065f46',
  '#064e3b',
  '#022c22',
]

const shadeTeal: MantineColorsTuple = [
  '#f0fdfa',
  '#ccfbf1',
  '#99f6e4',
  '#5eead4',
  '#2dd4bf',
  '#14b8a6',
  '#0d9488',
  '#0f766e',
  '#115e59',
  '#134e4a',
  '#042f2e',
]

const shadeCyan: MantineColorsTuple = [
  '#ecfeff',
  '#cffafe',
  '#a5f3fc',
  '#67e8f9',
  '#22d3ee',
  '#06b6d4',
  '#0891b2',
  '#0e7490',
  '#155e75',
  '#164e63',
  '#083344',
]

const shadeSky: MantineColorsTuple = [
  '#f0f9ff',
  '#e0f2fe',
  '#bae6fd',
  '#7dd3fc',
  '#38bdf8',
  '#0ea5e9',
  '#0284c7',
  '#0369a1',
  '#075985',
  '#0c4a6e',
  '#082f49',
]

const shadeBlue: MantineColorsTuple = [
  '#eff6ff',
  '#dbeafe',
  '#bfdbfe',
  '#93c5fd',
  '#60a5fa',
  '#3b82f6',
  '#2563eb',
  '#1d4ed8',
  '#1e40af',
  '#1e3a8a',
  '#172554',
]

const shadeIndigo: MantineColorsTuple = [
  '#eef2ff',
  '#e0e7ff',
  '#c7d2fe',
  '#a5b4fc',
  '#818cf8',
  '#6366f1',
  '#4f46e5',
  '#4338ca',
  '#3730a3',
  '#312e81',
  '#1e1b4b',
]

const shadeViolet: MantineColorsTuple = [
  '#f5f3ff',
  '#ede9fe',
  '#ddd6fe',
  '#c4b5fd',
  '#a78bfa',
  '#8b5cf6',
  '#7c3aed',
  '#6d28d9',
  '#5b21b6',
  '#4c1d95',
  '#2e1065',
]

const shadePurple: MantineColorsTuple = [
  '#faf5ff',
  '#f3e8ff',
  '#e9d5ff',
  '#d8b4fe',
  '#c084fc',
  '#a855f7',
  '#9333ea',
  '#7e22ce',
  '#6b21a8',
  '#581c87',
  '#3b0764',
]

const shadeFuchsia: MantineColorsTuple = [
  '#fdf4ff',
  '#fae8ff',
  '#f5d0fe',
  '#f0abfc',
  '#e879f9',
  '#d946ef',
  '#c026d3',
  '#a21caf',
  '#86198f',
  '#701a75',
  '#4a044e',
]

const shadePink: MantineColorsTuple = [
  '#fdf2f8',
  '#fce7f3',
  '#fbcfe8',
  '#f9a8d4',
  '#f472b6',
  '#ec4899',
  '#db2777',
  '#be185d',
  '#9d174d',
  '#831843',
  '#500724',
]

const shadeRose: MantineColorsTuple = [
  '#fff1f2',
  '#ffe4e6',
  '#fecdd3',
  '#fda4af',
  '#fb7185',
  '#f43f5e',
  '#e11d48',
  '#be123c',
  '#9f1239',
  '#881337',
  '#4c0519',
]

const shadeSlate: MantineColorsTuple = [
  '#f8fafc',
  '#f1f5f9',
  '#e2e8f0',
  '#cbd5e1',
  '#94a3b8',
  '#64748b',
  '#475569',
  '#334155',
  '#1e293b',
  '#0f172a',
  '#020617',
]

const shadeZinc: MantineColorsTuple = [
  '#fafafa',
  '#f4f4f5',
  '#e4e4e7',
  '#d4d4d8',
  '#a1a1aa',
  '#71717a',
  '#52525b',
  '#3f3f46',
  '#27272a',
  '#18181b',
  '#09090b',
]

// Mantine's `dark` palette, rebuilt from zinc so components without an
// override (Table, Switch, Checkbox, Pill, Badge, ...) stay on-palette. Each
// slot keeps the role Mantine gives it: 0 text, 2 dimmed, 4 border, 5 hover,
// 6 control/card fill, 7 body. Mantine reads 0–9 only; shade 10 exists so every
// palette has 11 shades.
const shadeDark: MantineColorsTuple = [
  shadeZinc[3],
  shadeZinc[4],
  shadeZinc[4],
  shadeZinc[5],
  shadeZinc[7],
  shadeZinc[7],
  shadeZinc[8],
  shadeZinc[9],
  shadeZinc[9],
  shadeZinc[10],
  shadeZinc[10],
]

const shadeNeutral: MantineColorsTuple = [
  '#fafafa',
  '#f5f5f5',
  '#e5e5e5',
  '#d4d4d4',
  '#a3a3a3',
  '#737373',
  '#525252',
  '#404040',
  '#262626',
  '#171717',
  '#0a0a0a',
]

const shadeStone: MantineColorsTuple = [
  '#fafaf9',
  '#f5f5f4',
  '#e7e5e4',
  '#d6d3d1',
  '#a8a29e',
  '#78716c',
  '#57534e',
  '#44403c',
  '#292524',
  '#1c1917',
  '#0c0a09',
]

const shadeShalionGreen: MantineColorsTuple = [
  '#D5FFBA',
  '#CDFAAD',
  '#C4F4A0',
  '#BCEF93',
  '#B4E986',
  '#a1e335',
  '#8BC72C',
  '#6A9E21',
  '#4A7517',
  '#2A4B0D',
  '#0A1B04',
]

const shadeShalionPersianPink: MantineColorsTuple = [
  '#FFCFED',
  '#FFC2E8',
  '#FFB5E3',
  '#FFA8DD',
  '#FF9BD8',
  '#FF87D4',
  '#E66FC0',
  '#B355A0',
  '#803B7F',
  '#5C2A5C',
  '#2B0D1F',
]

const shadeShalionGold: MantineColorsTuple = [
  '#FFE8B2',
  '#FFE29F',
  '#FFDC8C',
  '#FFD679',
  '#FFD066',
  '#FFC200',
  '#D9A400',
  '#B38600',
  '#8C6900',
  '#664B00',
  '#2E2105',
]

const shadeShalionLavender: MantineColorsTuple = [
  '#E8DEFC',
  '#DFD0FA',
  '#D6C2F8',
  '#CDB4F7',
  '#C4A6F5',
  '#B57DFF',
  '#9D6EE5',
  '#8559CC',
  '#6D44B3',
  '#522F99',
  '#170042',
]

const shadeShalionCarmine: MantineColorsTuple = [
  '#FFCFCC',
  '#FFBFBB',
  '#FFAFAA',
  '#FF9F99',
  '#FF8F88',
  '#FF435A',
  '#E63950',
  '#CC2F45',
  '#B3253B',
  '#801A30',
  '#30031A',
]

const shadeShalionMarl: MantineColorsTuple = [
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
  '#F0EEEB',
]

const shadeShalionSmoke: MantineColorsTuple = [
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
  '#F2F2F2',
]

const shadeShalionMaestroUserMessage: MantineColorsTuple = [
  '#e9eef6',
  '#d4dded',
  '#bfcce4',
  '#aabbdb',
  '#95aad2',
  '#8099c9',
  '#6b88c0',
  '#5677b7',
  '#4166ae',
  '#2c55a5',
  '#17449c',
]

const colors = {
  red: shadeRed,
  orange: shadeOrange,
  amber: shadeAmber,
  yellow: shadeYellow,
  lime: shadeLime,
  green: shadeGreen,
  emerald: shadeEmerald,
  teal: shadeTeal,
  cyan: shadeCyan,
  sky: shadeSky,
  blue: shadeBlue,
  indigo: shadeIndigo,
  violet: shadeViolet,
  purple: shadePurple,
  fuchsia: shadeFuchsia,
  pink: shadePink,
  rose: shadeRose,
  slate: shadeSlate,
  // `gray` aliases zinc: one neutral scale across the app and Mantine defaults.
  gray: shadeZinc,
  zinc: shadeZinc,
  dark: shadeDark,
  neutral: shadeNeutral,
  stone: shadeStone,
  'energy-green': shadeShalionGreen,
  smoke: shadeShalionSmoke,
  marl: shadeShalionMarl,
  persian: shadeShalionPersianPink,
  gold: shadeShalionGold,
  lavender: shadeShalionLavender,
  carmine: shadeShalionCarmine,
  'shalion-maestro-user-message': shadeShalionMaestroUserMessage,
}

export const LIGHT_PRIMARY_COLORS = ['energy-green', 'lavender', 'gold', 'persian']
export const DARK_PRIMARY_COLORS = ['energy-green']

export default colors
